import { Bits } from './bits';

export enum AudiencePermissions {
	CanAccessAudience = Bits.Bit1,
	AudienceCreate = Bits.Bit2,
	AudienceEdit = Bits.Bit3,
	AudienceDelete = Bits.Bit4
}
